export const Confirmation = () => {

    return (

 <div className='main about'>

                <div className='aside'><div></div></div>

                <div className='content has-aside static'>
                    
                 <h1>You are now pre-registered for Flintt.</h1>
                        <p>We've emailed you with a link to verify your account. Please check your spam folder.</p>
                        <p>We'll email you again when the platform goes live and your free month of Premium begins.</p>
                </div> 
            </div>
    )
}